<template>
    <v-container fluid>
      <v-dialog v-model="this.$store.getters['Auth/is_doc_open']" max-width="500px" persistent>
        <v-card>
          <v-card-title>
            <h4 class="headline">{{ formTitle }}</h4>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col class="colll" cols="12" sm="12" md="12">
                  <v-select
                    :items="this.$store.getters['Auth/get_all_legal_form'].document_types"
                    v-model="doc.type"
                    label="Sélectionner le type de dossier"
                    item-text="description"
                    item-value="status"
                  ></v-select>
                  <v-text-field v-model="doc.object" label="Saisir l’objet du dossier"></v-text-field>
                
                  <v-select
                    :items="listNoticeFilteredFromDocId()"
                    v-model="doc.notice"
                    v-on:change="UsersToSelect()"
                    label="Sélectionner l’avis spécifique du dossier d’appel à la concurrence"
                    :disabled="noticeType.status === 1"
                    item-text="object"
                    item-value="id"
                  >
                  </v-select>
                  <v-file-input
                    v-model="doc.file"
                    placeholder="Charger le fichier"
                    label="Insérer le fichier du dossier de consultation"
                    multiple
                    prepend-icon="mdi-paperclip"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip small label color="primary">{{ text }}</v-chip>
                    </template>
                  </v-file-input>
                  <v-file-input
                    v-model="doc.file_letter"
                    placeholder="Charger le fichier"
                    label="Insérer le fichier de la lettre à joindre"
                    multiple
                    prepend-icon="mdi-paperclip"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip small label color="primary">{{ text }}</v-chip>
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="close_doc" small>ANNULER L'ENVOI</v-btn>
            <v-btn
              color="green darken-1"
              :loading="this.$store.getters['Auth/loadDoc']"
              small
              text
              @click="addNoticeForAno"
              >ENVOYER LE DOSSIER</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-data-table
        locale="fr"
        :headers="headers"
        @click:row="goto"
        :search="search"
        no-data-text="Aucun dossier de consultations disponible"
        :items="this.$store.getters['Auth/getListDoc']"
        sort-by="createdAt"
        class="elevation-1 mb-5 px-5"
      >
        <template v-slot:[`item.valid`]="{ item }">
          <v-chip label small outlined :color="`${item.valid ? 'green' : 'red'}`">
                    {{ formatValid(item.valid) }}
          </v-chip>
        </template>
        <template v-slot:top>
          <v-toolbar flat color="white" class="mb-5">
            <v-toolbar-title v-show="$vuetify.breakpoint.mdAndUp">Liste des dossiers envoyés</v-toolbar-title>
            <v-divider class="mx-4" inset vertical v-show="$vuetify.breakpoint.mdAndUp"></v-divider>
            <v-spacer v-show="$vuetify.breakpoint.mdAndUp"></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Recherchez un dossier de consultation"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn small color="primary" dark class="mb-2" @click="open_doc">
              <v-icon small class="mr-2">mdi-plus</v-icon>ENVOYER UN NOUVEAU DOSSIER
            </v-btn>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-container>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/index.css";
  
  export default {
    components: { DatePicker },
    data: () => ({
      search: "",
      NoticeFiltered: [],
      items: [
        {
          text: "Tableau de bord",
          disabled: false,
          href: "/dashboard"
        },
        {
          text: "Mes Documents",
          disabled: true
        }
      ],
      dog: true,
      noticeType: [], 
      doc: {
        object: "",
        type: [],
        notice: [],
        file: [],
        file_letter: [],
      },
      dialog: false,
      headers: [
        {
          text: "Objet du dossier",
          sortable: true,
          value: "object"
        },
        { text: "Type de dossier de consultation", value: "documentType.title" },
        { text: "Avis concerné", value: "object", sortable: false },
        {
          text: "Status",
          sortable: false,
          filterable: false,
          value: "valid",
          align: "center",
          formatValid: (value) => (value ? "validé" : "non validé")
       }
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: "",
        calories: "",
        fat: 0,
        carbs: 0,
        protein: 0
      },
      defaultItem: {
        name: "",
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0
      }
    }),
    filters: {
      date(val) {
        return val ? val.toLocaleString() : "";
      }
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1
          ? "Envoi d’un nouvel dossier de consultation"
          : "Création du Plan de Passation des Marchés";
      }
    },
    watch: {
      dialog(val) {
        val || this.close();
      }
    },
    created() {
      this.$store.dispatch("Auth/loadAllNotice");
      this.$store.dispatch("Auth/loadAllDoc");
      this.$store.dispatch("Auth/getData");
    },
    methods: {
      ...mapActions({
        addDocForAno: "Auth/addDocForAno",
        loadAllNotice: "Auth/loadAllNotice"
      }),
  
      open_doc() {
        this.$store.commit("Auth/OPEN_DOC", true);
      },
      formatValid(value) {
            return this.headers.find(header => header.value === "valid").formatValid(value);
        },
      //FONCTION DE VERIFICATION LIEN AVEC DOSSIER
      listNoticeFilteredFromDocId() {
        return this.$store.getters["Auth/getListAvis"].filter(item => {
          switch (this.doc.type) {
            case 1:
              return item.noticeType.status == 2;
            case 2:
              return item.noticeType.status == 3;
            case 3:
              return item.noticeType.status == 4;
            case 4:
              return item.noticeType.status == 6;
            case 5:
              return item.noticeType.status == 5;
            case 6:
              return item.noticeType.status == 7;
            case 7:
              return item.noticeType.status == 7;
          }
        });
      },
      async UsersToSelect() {
        await this.listNoticeFilteredFromDocId();
        if (this.doc.notice) {
          this.$store.dispatch("Auth/getNotice", this.doc.notice);
        }
      },
      close_doc() {
        this.$store.commit("Auth/OPEN_DOC", false);
      },
      goto(value) {
        const { id } = value;
        this.$router.push({ name: "showDossierAnoAc", params: { id: id } });
      },
      addNoticeForAno() {
        const data = new FormData();
        data.append("object", this.doc.object);
        data.append("doc_type", this.doc.type);
        data.append("notice_id", this.doc.notice);
        if (this.doc.file || this.doc.file_letter) {
          data.append("file", this.doc.file[0]);
          data.append("file_letter", this.doc.file_letter[0]);
        } else {
          data.append("file", null);
          data.append("file_letter", null);
        }
        this.addDocForAno(data);
  
        this.doc.object = "";
        this.doc.type = [];
        this.doc.notice = [];
        this.doc.file = [];
        this.doc.file_letter = [];
      },
      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = { ...item };
        this.dialog = true;
      },
  
      deleteItem(item) {
        const index = this.desserts.indexOf(item);
        confirm("Are you sure you want to delete this item?") && this.desserts.splice(index, 1);
      },
      getPPM(item) {
        console.log(item);
        this.$router.push({ name: "user", params: { ppm: item } });
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = { ...this.defaultItem };
          this.editedIndex = -1;
        });
      },
  
      save() {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
        } else {
          this.desserts.push(this.editedItem);
        }
        this.close();
      }
    }
  };
  </script>
  <style scoped>
  .vue-daterange-picker {
    width: 100%;
  }
  .mx-datepicker {
    width: 100%;
  }
  .v-card__text {
    width: 100% !important;
  }
  </style>
  